var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataRecovery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10790_64461)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_10790_64461)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4562 15.1949C18.4562 13.4872 19.8854 12.1416 21.5999 12.1416C23.3144 12.1416 24.7437 13.4872 24.7437 15.1949C24.7437 16.9025 23.3144 18.2481 21.5999 18.2481C19.8854 18.2481 18.4562 16.9025 18.4562 15.1949ZM21.5999 13.3916C20.5323 13.3916 19.7062 14.2203 19.7062 15.1949C19.7062 16.1694 20.5323 16.9981 21.5999 16.9981C22.6675 16.9981 23.4937 16.1694 23.4937 15.1949C23.4937 14.2203 22.6675 13.3916 21.5999 13.3916ZM21.52 21.165C19.368 21.165 17.77 22.8338 17.77 24.9091V26.2202C17.77 26.5654 17.4902 26.8452 17.145 26.8452C16.7998 26.8452 16.52 26.5654 16.52 26.2202V24.9091C16.52 22.1584 18.6628 19.915 21.52 19.915C24.3476 19.915 26.68 22.1292 26.68 24.9091V26.2202C26.68 26.5654 26.4002 26.8452 26.055 26.8452C25.7098 26.8452 25.43 26.5654 25.43 26.2202V24.9091C25.43 22.8631 23.7016 21.165 21.52 21.165ZM20.709 28.892C20.465 28.648 20.0692 28.648 19.8251 28.892C19.5811 29.1361 19.5811 29.5318 19.8251 29.7759L20.0433 29.9941C17.9727 29.865 16.1384 29.4834 14.7555 28.9456C13.8931 28.6102 13.2379 28.2263 12.809 27.8319C12.3938 27.4501 12.235 27.1033 12.2255 26.8064C12.2856 26.2824 12.5843 25.8148 13.0359 25.5401C13.3308 25.3607 13.4245 24.9763 13.2451 24.6813C13.0657 24.3864 12.6812 24.2927 12.3863 24.4721C11.589 24.957 11.0671 25.7895 10.978 26.7184C10.9761 26.7383 10.9751 26.7582 10.9751 26.7781C10.9751 27.5491 11.3793 28.2154 11.9629 28.752C12.546 29.2881 13.3552 29.7422 14.3024 30.1106C15.8657 30.7186 17.8913 31.1264 20.1317 31.2515L19.8251 31.558C19.5811 31.8021 19.5811 32.1978 19.8251 32.4419C20.0692 32.686 20.465 32.686 20.709 32.4419L22.0345 31.1165C22.152 31.0028 22.2251 30.8435 22.2251 30.6671C22.2251 30.6671 22.2251 30.667 22.2251 30.667C22.2251 30.6539 22.2247 30.6408 22.2239 30.6278C22.2204 30.5726 22.2097 30.5177 22.1916 30.4648C22.1618 30.3772 22.1119 30.2949 22.042 30.225L20.709 28.892ZM29.9548 24.6813C30.1341 24.3864 30.5186 24.2927 30.8135 24.4721C31.6108 24.957 32.1328 25.7895 32.2219 26.7184C32.2238 26.7383 32.2248 26.7582 32.2248 26.7781C32.2248 27.9506 31.3067 28.8706 30.147 29.5244C28.9506 30.1989 27.3023 30.7091 25.4183 31.0036C25.0773 31.0569 24.7576 30.8237 24.7043 30.4826C24.651 30.1416 24.8842 29.8219 25.2252 29.7686C27.0193 29.4881 28.5099 29.0123 29.5331 28.4355C30.5716 27.8501 30.9591 27.2656 30.9743 26.8062C30.9142 26.2823 30.6156 25.8147 30.164 25.5401C29.8691 25.3607 29.7754 24.9763 29.9548 24.6813Z",
    fill: "#1B202C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10790_64461",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10790_64461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataRecovery);
export default __webpack_public_path__ + "static/media/data-recovery.5b54650bad62a6fd2c6ba0c681137caf.svg";
export { ForwardRef as ReactComponent };